import { AddProductErrorCode } from "@jti/magento";
import type { MagentoGraphQLRequestClientError } from "@jti/magento-api-v2";

const errorMessagesMap = [
  {
    magentoErrorKey: "Please specify product option",
    translationKey: "productdetails.addproduct.error.options",
  },
  {
    magentoErrorKey: `Product that you are trying to add is not available`,
    translationKey: "productdetails.addproduct.error.unavailable",
  },
  {
    magentoErrorKey: `The requested qty is not available`,
    translationKey: "productdetails.flavours.outOfStock",
  },
  {
    magentoErrorKey: "Product quantity limit exceeded",
    translationKey: "productdetails.addproduct.error.limit",
  },
  {
    magentoErrorKey: "Please select all required options",
    translationKey: "productdetails.addproduct.error.required",
  },
  {
    magentoErrorKey: "Invalid amount of bundle product options selected",
    translationKey: "productdetails.addproduct.error.bundleAmount",
  },
  {
    magentoErrorKey: "Provided quantity for the selection are empty or invalid",
    translationKey: "productdetails.addproduct.error.bundleAmount",
  },
  {
    magentoErrorKey: "Order limit exceeded",
    translationKey: "productdetails.addproduct.error.orderLimit",
  },
];

const errorCodesMessagesMap: { [key in AddProductErrorCode]: string } = {
  [AddProductErrorCode.PRODUCT_EXISTS_IN_SUBSCRIPTION]: "productdetails.addproduct.error.already_in_subscription",
};

type ErrorMessageType = (typeof errorMessagesMap)[0];

export const parseAddToCartErrorMessage = (data: MagentoGraphQLRequestClientError): string => {
  const currentErrorMessage = data?.message?.toString().toLowerCase();
  const errorCode = data.errorCodes?.[0];
  const messageFromErrorCode = errorCodesMessagesMap[errorCode as AddProductErrorCode];

  if (messageFromErrorCode) {
    return messageFromErrorCode;
  }

  if (currentErrorMessage) {
    const currentMessage = errorMessagesMap.find(
      (element: ErrorMessageType) => currentErrorMessage.indexOf(element.magentoErrorKey.toLowerCase()) !== -1
    );

    if (currentMessage) {
      return currentMessage.translationKey;
    }
  }

  return "productdetails.addproduct.error.general";
};
